import { UserStatus } from 'chaika-enums';
import { getCommonStatusTranslation } from '@utils/enumTranslation';

export function getUserStatusTitle(status: UserStatus): string {
    return getCommonStatusTranslation(status);
}
